import { type IEditableFieldConfigResponse } from '../types/configs';

export function generateUnionOfEditableFields(operations: Record<string, IEditableFieldConfigResponse>) {
  const unionOfEditableFields = new Set<string>();

  Object.keys(operations).forEach((operationKey) => {
    const operation = operations[operationKey]!;
    operation.mandatoryFields.forEach((field) => unionOfEditableFields.add(field));
    operation.optionalFields.forEach((field) => unionOfEditableFields.add(field));
  });

  return unionOfEditableFields;
}
